import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

interface ExecFunctionParams {
  fn: string;
  input: Record<string, unknown>;
}

interface ExecFunctionResponse {
  result: unknown;
}

export const execApi = {
  executeFunction: async ({
    fn,
    input,
  }: ExecFunctionParams): Promise<ExecFunctionResponse> => {
    const response = await axios.post('/api/exec-fn', { fn, input });
    return response.data;
  },
};

export const useExecuteFunction = () => {
  return useMutation({
    mutationFn: (params: ExecFunctionParams) => execApi.executeFunction(params),
  });
};
